import { HubConnection } from '@microsoft/signalr';
import { IErrorScreen } from 'shared/models/IErrorScreen.interface';
import { INotificationFromStore } from 'shared/models/INotification.interface';

export interface ISignalRConnectionState {
  isConnected: boolean;
  connecting: boolean;
  signalRConnection: HubConnection | null;
}

export const SIGNALR_CONNECTION_INITIAL_STATE: ISignalRConnectionState = {
  isConnected: false,
  connecting: false,
  signalRConnection: null,
};

export interface INotificationsFromStoreState {
  notifications: INotificationFromStore[] | null;
  error: string;
  isFetchingData: boolean;
}

export const NOTIFICATIONS_FROM_STORE_INITIAL_STATE: INotificationsFromStoreState =
  {
    notifications: null,
    error: '',
    isFetchingData: false,
  };

export interface IGetSystemMaintenanceState {
  maintenance: IErrorScreen | null;
  error: string;
  isFetchingData: boolean;
}

export const GET_SYSTEM_MAINTENANCE_INITIAL_STATE: IGetSystemMaintenanceState =
  {
    maintenance: null,
    error: '',
    isFetchingData: false,
  };

export interface IRBACState {
  roles: string[];
  permissions: IRBACPermission[];
  persona: string;
}

export interface IRBACPermission {
  resource: string;
  operation: string;
}

export const RBAC_CONFIG_INITIAL_STATE: IRBACState = {
  roles: [],
  permissions: [],
  persona: '',
};
